import styled from 'styled-components';

export default styled.div`
  transform: translate(0, 70px);
  display: flex;
  flex-direction: row;
`;
